import { forwardRef, type InputHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, type = "text", ...props }, ref) => {
    return (
      <input
        type={type}
        ref={ref}
        className={cn(
          "flex h-10 w-full rounded-md border bg-bg-card px-3 py-2 text-sm shadow-2xs",
          "placeholder:text-text-muted transition-[border-color,box-shadow] duration-150",
          "focus:outline-none focus:border-primary focus:ring-[3px] focus:ring-primary/15",
          "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-bg-muted/50",
          error
            ? "border-danger focus:border-danger focus:ring-danger/15"
            : "border-border hover:border-border-strong",
          className,
        )}
        {...props}
      />
    );
  },
);

Input.displayName = "Input";
